module.exports = "## List\n[Lists](https://www.google.com/design/spec/components/lists.html#) are used to present\nmultiple items vertically as a single continuous element. They can be configured for\nmany uses such as a contacts list, nested lists, etc.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/List/README.md
 ** module id = 1015
 ** module chunks = 0
 **/